export const en = {
  common: {
    brand: 'InChi Solutions Pvt Ltd',
    brandShort: 'InChi Solutions Hub',
    openMenu: 'Open menu',
    closeMenu: 'Close menu',
    goToSlide: 'Go to slide {{n}}',
    viewStory: 'View story {{n}}',
  },
  header: {
    home: 'Home',
    jobMarketplace: 'Job Marketplace',
    services: 'Services',
    clientPortal: 'Client Portal',
    tradeNetwork: 'Trade Network',
    successStories: 'Success Stories',
    erp: 'HR & Payroll ERP',
    login: 'Login',
    logout: 'Logout',
    getStarted: 'Get Started',
    langEn: 'EN',
    langZh: '中文',
  },
  footer: {
    tagline:
      'Precision in Partnership. Transforming businesses through comprehensive HR solutions, global trade networks, and engineering excellence.',
    services: 'Services',
    company: 'Company',
    resources: 'Resources',
    legal: 'Legal',
    hrSolutions: 'HR Solutions',
    jobMarketplace: 'Job Marketplace',
    tradeNetwork: 'Trade Network',
    engineeringServices: 'Engineering Services',
    aboutUs: 'About Us',
    successStories: 'Success Stories',
    clientPortal: 'Client Portal',
    contact: 'Contact',
    blog: 'Blog',
    caseStudies: 'Case Studies',
    marketReports: 'Market Reports',
    careerGuide: 'Career Guide',
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Terms of Service',
    cookiePolicy: 'Cookie Policy',
    compliance: 'Compliance',
    copyright: '© {{year}} InChi Solutions Hub. All rights reserved.',
    location: 'Bengaluru, India',
    isoCertified: 'ISO 9001:2015 Certified',
  },
  home: {
    seo: {
      title:
        'INCHI Solutions Hub - Precision in Partnership | HR, Trade & Engineering Excellence',
      description:
        'Transform your business with InChi Solutions Pvt Ltd - comprehensive HR services, global trade networks, and engineering solutions. 880+ projects, 678+ clients, 112 industry recognitions. Your trusted partner for business growth.',
      keywords:
        'HR solutions, talent acquisition, job marketplace, global trade network, engineering services, business partnerships, recruitment services, supplier network',
    },
    hero: {
      isoBadge: 'ISO 9001:2015 Certified',
      scheduleConsultation: 'Schedule Consultation',
      clientSatisfaction: 'Client Satisfaction',
      slides: [
        {
          title: 'Precision in Partnership',
          subtitle: 'Transforming Business Challenges into Streamlined Solutions',
          description:
            "Your trusted partner for comprehensive HR solutions, global trade networks, and engineering excellence. Join 678+ organizations who've achieved success with us.",
          imageAlt: 'Professional business team collaborating in a bright corporate office',
          cta: 'Explore Services',
          statsLabel: 'Projects Completed',
        },
        {
          title: 'Your Success, Our Expertise',
          subtitle: 'Global Networks, Local Understanding',
          description:
            'Access world-class talent, international trade opportunities, and engineering solutions tailored to your business needs. Experience the power of integrated services.',
          imageAlt:
            'International business professionals collaborating in a modern glass office at sunset',
          cta: 'Find Talent',
          statsLabel: 'Organizations Served',
        },
        {
          title: 'Innovation Meets Reliability',
          subtitle: "Building Tomorrow's Success Stories Today",
          description:
            'From startup scaling to enterprise transformation, we deliver solutions that drive growth. Discover why industry leaders trust InChi Solutions Pvt Ltd.',
          imageAlt: 'Dynamic business team celebrating success in a modern startup office',
          cta: 'View Success Stories',
          statsLabel: 'Industry Recognitions',
        },
      ],
    },
    stats: {
      badge: 'Proven Track Record',
      title: 'Numbers That Speak for Themselves',
      subtitle:
        'Our commitment to excellence is reflected in every metric. Join the growing community of successful partnerships.',
      items: [
        {
          label: 'Projects Completed',
          description: 'Successfully delivered across industries',
        },
        {
          label: 'Organizations Served',
          description: 'From startups to Fortune 500',
        },
        {
          label: 'Industry Recognitions',
          description: 'Excellence acknowledged globally',
        },
        {
          label: 'Professionals Placed',
          description: 'Career transformations enabled',
        },
      ],
      satisfaction: 'Client Satisfaction Rate',
      support: 'Support Availability',
      response: 'Average Response Time',
    },
    services: {
      badge: 'Comprehensive Solutions',
      title: 'Your One-Stop Business Partner',
      subtitle:
        'From talent acquisition to global trade, we provide integrated services that drive your business forward. Experience the power of unified solutions.',
      explore: 'Explore Service',
      viewAll: 'View All Services',
      items: [
        {
          title: 'HR Solutions & Talent Acquisition',
          description:
            'End-to-end human resource management from recruitment to retention. Access our extensive talent pool and streamlined hiring processes.',
          imageAlt:
            'Professional HR manager conducting interview with candidate in modern office with glass walls and contemporary furniture',
          features: [
            'Executive Search',
            'Mass Recruitment',
            'Payroll Management',
            'Training & Development',
          ],
        },
        {
          title: 'Job Marketplace',
          description:
            'Connect with top employers and discover career opportunities across industries. Advanced matching algorithms ensure perfect job-candidate fit.',
          imageAlt:
            'Young professional woman reviewing job opportunities on laptop in bright modern coworking space with plants and natural lighting',
          features: [
            'Smart Job Matching',
            'Company Profiles',
            'Application Tracking',
            'Career Resources',
          ],
        },
        {
          title: 'Global Trade Network',
          description:
            'Expand your business internationally with our trusted supplier networks and trade facilitation services across multiple continents.',
          imageAlt:
            'International shipping containers at busy port terminal with cargo ships and cranes against blue sky at sunset',
          features: [
            'Supplier Sourcing',
            'Trade Compliance',
            'Logistics Support',
            'Market Intelligence',
          ],
        },
        {
          title: 'Engineering Services',
          description:
            'Specialized engineering solutions for complex projects. From design to implementation, we deliver technical excellence.',
          imageAlt:
            'Engineering team analyzing technical blueprints and CAD designs on large monitors in modern industrial facility',
          features: [
            'Project Management',
            'Technical Consulting',
            'Quality Assurance',
            'Innovation Labs',
          ],
        },
      ],
    },
    stories: {
      badge: 'Client Success Stories',
      title: 'Transforming Challenges into Triumphs',
      subtitle:
        "Real results from real partnerships. Discover how we've helped businesses across industries achieve their goals.",
      challenge: 'Challenge',
      solution: 'Solution',
      result: 'Result',
      viewAll: 'View All Stories',
      items: [
        {
          company: 'TechVision Solutions',
          industry: 'Information Technology',
          logoAlt:
            'Modern tech company office with glass walls and contemporary design featuring blue and white color scheme',
          challenge: 'Rapid scaling required 200+ technical hires within 6 months',
          solution: 'Implemented end-to-end recruitment strategy with dedicated talent pools',
          result: 'Successfully placed 215 professionals with 95% retention rate',
          metrics: [
            { label: 'Positions Filled', value: '215' },
            { label: 'Time Saved', value: '40%' },
            { label: 'Retention Rate', value: '95%' },
          ],
          testimonial:
            'InChi Solutions Pvt Ltd transformed our hiring process. Their understanding of technical talent and efficient processes helped us scale faster than we imagined possible.',
          author: 'Rajesh Kumar',
          position: 'Chief Technology Officer',
          imageAlt:
            'Professional Indian male executive in formal business attire smiling confidently in modern corporate office setting',
        },
        {
          company: 'Global Manufacturing Corp',
          industry: 'Manufacturing & Engineering',
          logoAlt:
            'Industrial manufacturing facility with modern machinery and automated production lines in clean factory environment',
          challenge: 'Needed reliable international suppliers for critical components',
          solution: 'Leveraged global trade network to identify and vet 50+ suppliers',
          result: 'Reduced procurement costs by 30% while improving quality standards',
          metrics: [
            { label: 'Cost Reduction', value: '30%' },
            { label: 'Suppliers Vetted', value: '50+' },
            { label: 'Quality Improvement', value: '25%' },
          ],
          testimonial:
            'The trade network expertise NCHI provided was invaluable. They connected us with reliable suppliers and handled all compliance complexities seamlessly.',
          author: 'Priya Sharma',
          position: 'Head of Procurement',
          imageAlt:
            'Professional Indian female business leader in elegant business suit reviewing documents in bright modern office',
        },
        {
          company: 'RetailMax India',
          industry: 'Retail & E-commerce',
          logoAlt:
            'Modern retail store interior with bright lighting organized product displays and contemporary shopping environment',
          challenge: 'Seasonal workforce management for 15 locations nationwide',
          solution: 'Developed flexible staffing model with training programs',
          result: 'Improved operational efficiency by 45% during peak seasons',
          metrics: [
            { label: 'Efficiency Gain', value: '45%' },
            { label: 'Locations Served', value: '15' },
            { label: 'Staff Trained', value: '500+' },
          ],
          testimonial:
            "NCHI's flexible staffing solutions and comprehensive training programs have been game-changers for our seasonal operations. Highly recommended!",
          author: 'Amit Patel',
          position: 'Operations Director',
          imageAlt:
            'Professional Indian male manager with beard wearing business casual attire smiling warmly in retail environment',
        },
      ],
    },
    trust: {
      badge: 'Trusted Excellence',
      title: 'Certified Quality, Proven Results',
      subtitle:
        'Our commitment to excellence is backed by industry certifications and trusted by leading organizations worldwide.',
      trustedBy: 'Trusted by Industry Leaders',
      clientsSay: 'What Our Clients Say',
      certifications: [
        { title: 'ISO 9001:2015', description: 'Quality Management' },
        { title: 'Industry Leader', description: '112 Recognitions' },
        { title: 'Data Security', description: 'GDPR Compliant' },
        { title: 'Verified Partner', description: 'Trusted Network' },
      ],
      testimonials: [
        {
          text: 'InChi Solutions Pvt Ltd has been instrumental in our growth. Their expertise in talent acquisition helped us build a world-class team.',
          author: 'Vikram Mehta',
          position: 'CEO, TechVision',
          imageAlt:
            'Professional Indian male CEO in formal business suit with confident expression in executive office',
        },
        {
          text: "The global trade network opened doors we didn't know existed. Outstanding service and reliable partnerships.",
          author: 'Anita Desai',
          position: 'Director, Global Trade Co',
          imageAlt:
            'Professional Indian female director in elegant business attire smiling warmly in modern corporate setting',
        },
        {
          text: "From recruitment to retention, NCHI handles everything seamlessly. They're true partners in our success.",
          author: 'Rahul Kapoor',
          position: 'HR Head, Innovation Labs',
          imageAlt:
            'Professional male HR executive in business casual attire with friendly demeanor in contemporary office',
        },
      ],
    },
    cta: {
      title: 'Ready to Transform Your Business?',
      subtitle:
        'Join 678+ organizations who trust InChi Solutions Pvt Ltd for their business needs. Start your journey to success today.',
      startPartnership: 'Start Partnership',
      clientPortal: 'Client Portal',
      getStarted: 'Get Started',
      actions: [
        {
          title: 'Find Your Dream Job',
          description: 'Browse thousands of opportunities',
        },
        {
          title: 'Hire Top Talent',
          description: 'Access our talent pool',
        },
        {
          title: 'Expand Globally',
          description: 'Connect with suppliers worldwide',
        },
        {
          title: 'Get Consultation',
          description: 'Speak with our experts',
        },
      ],
      isoTitle: 'ISO 9001:2015 Certified',
      isoDesc: 'Quality management excellence',
      supportTitle: '24/7 Support Available',
      supportDesc: 'Always here when you need us',
      recognitionTitle: 'Industry Recognition',
      recognitionDesc: '112 awards and counting',
    },
  },
};
